import axios from 'axios'
import { EmailFormProps } from '../interfaces/email.interface'

const BASE_URL = `https://us-central1-studied-theater-402920.cloudfunctions.net/waitlist`

export const sendEmailWaitlist = async (data: EmailFormProps) => {
    const result = await axios.post(`${BASE_URL}/user/entry`, data)
    return result.data
}

export const sendEmailWaitlistPlaces = async (data: EmailFormProps) => {
    const result = await axios.post(`${BASE_URL}/place/entry`, data)
    return result.data
}